import { render, staticRenderFns } from "./StyledArticle.vue?vue&type=template&id=fc26e6f6&scoped=true&"
import script from "./StyledArticle.vue?vue&type=script&lang=js&"
export * from "./StyledArticle.vue?vue&type=script&lang=js&"
import style0 from "./StyledArticle.vue?vue&type=style&index=0&id=fc26e6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc26e6f6",
  null
  
)

export default component.exports